import IAmount from "./IAmount";
import ISettingsLoanWallet from "./ISettingsLoanWallet";
import Amount from "./Amount";

export default class SettingsLoanWallet implements ISettingsLoanWallet {
    constructor(public preferredInstallment?: IAmount, public productCode?: string) {}
}
